<template>
  <div class="donate-carousel" v-if="ready">
    <h2>Choose design</h2>
    <VueSlickCarousel 
      :infinite="false"
      @afterChange="updateSelectedPackage"
    >
      <div class="slide" v-for="item in product.packages" :key="item.code">
        <div class="product-pack" :style="'background-image: url('+ item.img +')'"></div>
      </div>
    </VueSlickCarousel>
  </div>
</template>


<script>
import { mapState } from "vuex";
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  name: "WildcardCarousel",
  components: {
    VueSlickCarousel,
  },

  computed: {
    ready() {
      // Single wildcard product should not be displayed
      return this.product.packages.length > 1;
    },
    ...mapState({
      donation: (state) => state.donation.donation,
      product: (state) => state.product.product,
    }),
  },

  created() {
    this.updateSelectedPackage();
  },
  methods: {
    updateSelectedPackage(slideIndex) {
      const { code, img, pdf } = this.product.packages[slideIndex || 0];
      this.donation.packagecode = code;
      this.donation.wildcard.img = img;
      this.donation.wildcard.pdf = pdf;
    },
  },
};
</script>

<style scoped>
  .donate-carousel {
    position: relative;
    margin-bottom: 2rem;
  }
  .slide {
    position: relative;
    padding-top: 63%;
  }
  .product-pack {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>


// WEBPACK FOOTER //
// WildcardCarousel.vue?ceb1c6ca